/**
 * SALVIA-746 — nonce da Content-Security-Policy desta página.
 *
 * A política proíbe <style> inline sem nonce. O nginx gera um valor novo a
 * cada carregamento do index.html e o escreve em
 * `<meta name="csp-nonce" content="...">` (sub_filter sobre `__CSP_NONCE__`),
 * o MESMO que vai no header. Todo <style> criado em tempo de execução precisa
 * dele: o tema do Vuetify, a folha do PDF da receita e o autocomplete do
 * Quill.
 *
 * Em `npm run serve` não há nginx nem CSP: a meta fica com o marcador e a
 * função devolve undefined — nada é bloqueado, nada precisa de nonce.
 */
let cache;

export function cspNonce() {
  if (cache !== undefined) return cache || undefined;

  const valor = document
    .querySelector('meta[name="csp-nonce"]')
    ?.getAttribute("content");

  cache = valor && !valor.startsWith("__") ? valor : "";
  return cache || undefined;
}

/** Aplica o nonce num <style> criado à mão, antes de ele entrar na página. */
export function comNonce(elemento) {
  const nonce = cspNonce();
  if (nonce) elemento.setAttribute("nonce", nonce);
  return elemento;
}
